module.exports = __webpack_public_path__ + "search-icon.svg?1773577af435c01c2f3787b6fb846d59";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/search-icon.svg
// module id = 125
// module chunks = 0